import { combineReducers } from 'redux';

import * as systemActionTypes from '../../system/action-creator/actionTypes';

const byId = (state = {}, action) => {
  switch(action.type){
    case systemActionTypes.LOAD_USER_DATA_SUCCESS:
      return action.stations.byId;
    default:
      return state;
  }
}

const ids = (state = [], action) => {
  switch(action.type){
    case systemActionTypes.LOAD_USER_DATA_SUCCESS:
      return action.stations.ids;
    default:
      return state;
  }
}

export default combineReducers({
  byId,
  ids
});

const getCurrentState = state => state.userStations;

export const getStations = state => {
  const currentState = getCurrentState(state);
  return currentState.ids.map(id => currentState.byId[id]);
}